import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { linkRightMenu } from '@/vars'
import './style.sass'

export default defineComponent({
  setup () {
    const route = useRoute()

    let filterLinkRightMenu: any = []

    filterLinkRightMenu = linkRightMenu.filter((item: any) => {
      const itemId = item.places.indexOf(route.name)
      return itemId !== -1
    })

    return () => {
      return (
        <div class="right-menu-container main-content-two-columns-right-elem">
          {filterLinkRightMenu.map((item: any, id: number) =>
            item.aliases.indexOf(route.name) !== -1 ? (
              <router-link to={item.link} id="active-elem">{item.name}</router-link>
            ) : <router-link to={item.link} class="right-menu-item">{item.name}</router-link>
          )}
        </div>
      )
    }
  }
})